import { CanDeactivate } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IBasicModalComponentInstance, BasicModalOperationResult, DialogModalComponent } from 'src/app/shared/components/dialog-modal/dialog-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { rejects } from 'assert';
import { TranslateService } from '@ngx-translate/core';

export interface ComponentCanDeactivate {
    canDeactivate: () => boolean | Observable<boolean>;
}

@Injectable()
export class PendingChangesGuard implements CanDeactivate<ComponentCanDeactivate> {
    constructor(
        private modalService: NgbModal,
        private translate: TranslateService) { }

    async canDeactivate(component: ComponentCanDeactivate): Promise<boolean> {
        // if there are no pending changes, just allow deactivation; else confirm first
        return component.canDeactivate() ?
            true :
            await this.showWarningDialog();
    }

    async showWarningDialog(): Promise<boolean> {
        return new Promise((resolve, rejects) => {
            let continueAnyways = false;
            const modalRef = this.modalService.open(DialogModalComponent, {
                backdrop: 'static',
                keyboard: false
            });

            const modalInstance = modalRef.componentInstance as IBasicModalComponentInstance;
            modalInstance.title = this.translate.instant('pendingChangesGuard.modalTitle');
            modalInstance.type = BasicModalOperationResult.Warning;
            modalInstance.body = this.translate.instant('pendingChangesGuard.modalBody');
            modalInstance.buttons = [{
                text: this.translate.instant('pendingChangesGuard.cancel'),
                cssClass: 'btn btn-outline-dark',
                handler: async (btn) => {
                    continueAnyways = false;
                    resolve(continueAnyways);
                    modalInstance.closeModal();
                }
            }, {
                closeModalOnClick: false,
                text: this.translate.instant('pendingChangesGuard.accept'),
                cssClass: 'btn btn-success',
                handler: (btn) => {
                    continueAnyways = true;
                    resolve(continueAnyways)
                    modalInstance.closeModal();
                }
            },];
        });

    }
}